import { z } from 'zod'
import {
  SignalSchema,
  ZugmeldestelleSchema
} from '../../Generic/schema/generic.schema'
import { AuftragX_25Schema } from '../../Auftraege'

// Default constants
const DEFAULT_SIGNAL_ZUGMELDESTELLE = {
  signal: '',
  zugmeldestelle: {
    art: '' as const,
    name: ''
  }
}

const DEFAULT_AUFTRAG_7_10 = {
  enabled: true
}

const DEFAULT_AUFTRAG_7_20 = {
  enabled: false,
  field_7_21: DEFAULT_SIGNAL_ZUGMELDESTELLE
}

const DEFAULT_BEFEHL_7_FORM = {
  auftrag_7_10: DEFAULT_AUFTRAG_7_10,
  auftrag_7_20: DEFAULT_AUFTRAG_7_20,
  auftrag_7_25: {
    enabled: false
  }
}

// Schema definitions
export const SignalZugmeldestelleSchema = z
  .object({
    signal: SignalSchema,
    zugmeldestelle: ZugmeldestelleSchema
  })
  .default(() => structuredClone(DEFAULT_SIGNAL_ZUGMELDESTELLE))

const Auftrag7_10Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_7_10.enabled)
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_7_10))

// Base schema
const Auftrag7_20Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_7_20.enabled),
    field_7_21: SignalZugmeldestelleSchema
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_7_20))

// Base schema
const Befehl7FormSchemaBase = z
  .object({
    // Auftrag 7.10
    auftrag_7_10: Auftrag7_10Schema,

    // Auftrag 7.20
    auftrag_7_20: Auftrag7_20Schema,

    // Auftrag 7.25
    auftrag_7_25: AuftragX_25Schema
  })
  .default(() => structuredClone(DEFAULT_BEFEHL_7_FORM))

// Validation schema for Auftrag 7.20
const Auftrag7_20ValidationSchema = Auftrag7_20Schema.superRefine(
  (data, ctx) => {
    if (!data.enabled) return

    if (!data.field_7_21) {
      ctx.addIssue({
        code: 'custom',
        path: ['field_7_21'],
        message: 'common:validation.inputs_required'
      })
      return
    }

    const result = z
      .object({
        signal: SignalSchema,
        zugmeldestelle: ZugmeldestelleSchema
      })
      .safeParse(data.field_7_21)
    if (!result.success) {
      for (const issue of result.error.issues) {
        ctx.addIssue({
          ...issue,
          path: ['field_7_21', ...issue.path]
        })
      }
    }
  }
)

// Validation schema factory
export const createBefehl7FormValidationSchema = () => {
  return z
    .object({
      // Auftrag 7.10
      auftrag_7_10: Auftrag7_10Schema,

      // Auftrag 7.20
      auftrag_7_20: Auftrag7_20ValidationSchema,

      // Auftrag 7.25
      auftrag_7_25: AuftragX_25Schema
    })
    .default(() => structuredClone(DEFAULT_BEFEHL_7_FORM))
}

export const Befehl7FormSchema = Befehl7FormSchemaBase

export type Befehl7FormData = z.infer<typeof Befehl7FormSchemaBase>
